import React from 'react';

import {deprecatedTrackEvent} from 'analytics/Analytics';
import {pluralize} from 'BenchlingUtil';
import {INSIGHTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

import {WarehouseTableData} from '../warehouseModelsDataLayout';
import {DWD_MAXIMUM_NUMBER_TABLES_TO_ADD} from './diagram-layout/diagramLayoutConstants';
import {useDiagramLayoutContext} from './DiagramLayoutContext';

export interface WarehouseDiagramUnrelatedTablesButtonProps {
  tableData: WarehouseTableData;
  numberUnpopulatedRelatedTables: number;
}

export default function WarehouseDiagramUnrelatedTablesButton(
  props: WarehouseDiagramUnrelatedTablesButtonProps
): JSX.Element {
  const {addRelatedTables} = useDiagramLayoutContext();

  function handleAddRelatedTablesClick(): void {
    deprecatedTrackEvent(INSIGHTS_ANALYTICS_ACTIONS.ADDED_RELATED_TABLES_TO_WAREHOUSE_DIAGRAM, {
      expandedTableName: props.tableData.name,
    });
    addRelatedTables(props.tableData);
  }

  return (
    <Tooltip
      title={`Show ${Math.min(
        props.numberUnpopulatedRelatedTables,
        DWD_MAXIMUM_NUMBER_TABLES_TO_ADD
      )} other related ${pluralize(props.numberUnpopulatedRelatedTables, 'table', 'tables')}`}
    >
      <Button
        icon="erd"
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        size={ButtonSize.MINI}
        onClick={handleAddRelatedTablesClick}
      />
    </Tooltip>
  );
}
